export default __webpack_public_path__ + "static/media/map-poi-icon.4239f39b.svg";